/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const blockedSignupDomainSchema = z.object({
  createdAt: z.string().datetime().nullish(),
  domain: z.string().nullish(),
  id: z.string().uuid(),
  updatedAt: z.string().datetime().nullish(),
});

export type BlockedSignupDomain = z.infer<typeof blockedSignupDomainSchema>;
